module.exports = __webpack_public_path__ + "assets/pdf.6c9035aca8f15e30637b273bda5f4f8e.svg";